<template>
  <div @click="isOpen = false">
    <PageTagline :elements="tagline_elem" />

    <!-- Overlay di caricamento -->
    <CustomOverlay :show="overlay_show" text="Caricamento in corso, attendere...">

      <!--CARD PRINCIPALE DI CONTENIMENTO DELLA HOME -->
      <b-card title="Convenzioni special/On Demand" :sub-title="home_subtitle">

        <!-- PANNELLO DELLE CATEGORIE -->
        <div v-if="show_categorie">
          <b-row>
            <b-col class="text-md-left mt-3">
              <b-button pill size="sm" class="mr-2 mb-2" :to="{ name : 'gestione-pin' }">
                <font-awesome-icon icon="key"/> Gestione Pin Utente
              </b-button>
              <b-button pill size="sm" class="mr-2 mb-2" :to="{ name : 'stato-voucher' }">
                <font-awesome-icon icon="qrcode"/> Stato Voucher Multiuso
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mt-3" v-for="( row_elem, index ) in parted_category" :key="index" >
            <b-col class="text-center" v-for="( col_elem, index ) in row_elem" :key="index" :cols="calculate_bootstrap_col_class(parted_category)">
              <b-link @click="display_fornitori(col_elem.id)">
                <div class="mt-3 category-badge">
                  <b-img fluid :src="col_elem.url_icona" alt="LogoCategoria"></b-img>
                  <h6 class="mt-4 font-italic">{{col_elem.nome}}</h6>
                </div>
              </b-link>
              <!--<b-button v-if="(col_elem.id===8)" @click="display_map(col_elem.id)" variant="primary">
                Mappa
              </b-button>-->
              </b-col>
            </b-row>


        </div>

        <!-- PANNELLO DEI FORNITORI "NON AZIENDALI" -->
        <!-- Tutti gli altri fornitori che non sono quelli aziendali -->
        <div v-if="show_fornitori">
          <b-button pill size="sm" @click="display_categorie">
            <b-icon icon="caret-left-fill"></b-icon>Torna alle categorie
          </b-button>

          <div class="mt-2 mb-3 justify-content-between align-items-center d-flex">
            <h5 class="mb-0">Fornitori Special</h5>
            <b-form-select class="w-25" v-model="selectedProvince" :options="optionsProvince"></b-form-select>
          </div>

          <div class="mt-1 d-flex align-items-center flex-column flex-sm-column flex-md-row " v-for="( row_elem, index ) in filter_by_provice" :key="index" >
            <b-col class="text-center" v-for="( col_elem, index ) in row_elem" :key="index" :cols="calculate_bootstrap_col_class(filter_by_provice)">
              <b-link @click="apri_vetrina( col_elem )">
                <div class="mt-1 selectedCard d-flex justify-content-center align-items-center " style="height: 25vh; width: 100%;">
                  <div v-if="col_elem.logo_url" class="d-flex justify-content-center align-items-center " style="height: 100%; width: 100%;" >
                    <b-img fluid :src="col_elem.logo_url" alt="LogoFornitore"></b-img>

                  </div>
                  <div v-else>
                    <div class="forn-name-container">
                      <h4>{{col_elem.nome}} {{col_elem.cognome}} </h4>
                    </div>
                  </div>
                </div>
              </b-link>
            </b-col>
          </div>
        </div>


        <!-- PANNELLO DEI FORNITORI DI MARCA -->
        <div v-if="show_fornitori_marche">
          <b-button pill size="sm" @click="display_categorie">
            <b-icon icon="caret-left-fill"></b-icon>Torna alle categorie
          </b-button>

          <div class="mt-2 mb-3 justify-content-between align-items-center d-flex">
            <h5 class="mb-0">Welfare di Marca</h5>
            <b-form-select class="w-25" v-model="selectedProvinceMarca" :options="optionsProvinceMarca"></b-form-select>
          </div>

          <div class="mt-1 d-flex align-items-center flex-column flex-sm-column flex-md-row " v-for="( row_elem, index ) in filter_by_provice_by_marca" :key="index" >
            <b-col class="text-center" v-for="( col_elem, index ) in row_elem" :key="index" :cols="calculate_bootstrap_col_class(filter_by_provice_by_marca)">
              <b-link @click="apri_vetrina( col_elem )">
                <div class="mt-1 selectedCard d-flex justify-content-center align-items-center " style="height: 25vh; width: 100%;">
                  <div v-if="col_elem.logo_url" class="d-flex justify-content-center align-items-center " style="height: 100%; width: 100%;" >
                    <b-img fluid :src="col_elem.logo_url" alt="LogoFornitore"></b-img>
                  </div>
                  <div v-else>
                    <div style="height: 100%; width: 100%;" class=" d-flex justify-content-center align-items-center">
                      <h4>{{col_elem.nome}} {{col_elem.cognome}}</h4>
                    </div>
                  </div>
                </div>
              </b-link>
            </b-col>
          </div>
        </div>


        <!-- PANNELLO DEI FORNITORI MAP "NON AZIENDALI" -->
        <!-- Tutti gli altri fornitori che non sono quelli aziendali -->



        <!-- PANNELLO DEI FORNITORI AZIENDALI -->
        <!-- Ha un pannello implementato per proprio conto perchè a differenza degli altri         -->
        <!-- questa categoria deve avere una sottodivisione per provincie quindi l'html prodotto   -->
        <!-- è diverso. Implementa inoltre un filtro per categorie di servizio e ricerca per nome. -->
        <div v-if="show_fornitori_aziendali">
          <div id="map-message" class="alert alert-info">
            <span class="alert-icon">ℹ️</span>
            <span>&nbsp;Attenzione: non tutti i fornitori sono disponibili sulla mappa. Per conoscere l'elenco completo, scorri la pagina o ricerca un fornitore utilizzando il box di ricerca!</span>
          </div>

          <div class="filters-row">
              <div id="search-box" class="search-box">
                <input
                    type="text"
                    v-model="filterText"
                    @input="applyFilter"

                    placeholder="Cerca fornitore..."
                    class="search-input"
                >
              </div>

              <div class="multi-select" @click.stop>
                <button class="multi-select-btn" @click="isOpen = !isOpen">
                  <div class="chips-container">
                    <span v-if="filteredCategories.length === 0">Tutte le categorie di servizio</span>

                    <span
                        v-for="cat in filteredCategories"
                        :key="cat.value"
                        class="chip"
                    >
                    {{ cat.label }}
                      <span class="chip-remove" @click.stop="removeCategory(cat.value)">×</span>
                    </span>
                  </div>

                  <span class="arrow" :class="{ open: isOpen }">▼</span>
                </button>

                <div class="multi-select-menu" v-if="isOpen">
                  <div
                      class="multi-select-item"
                      v-for="cat in availableCategories"
                      :key="cat.value"
                      @click="toggleCategory(cat.value)"
                  >
                    <input
                        type="checkbox"
                        :checked="selectedCategories.includes(cat.value)"

                    />
                    <label>{{ cat.label }}</label>
                  </div>
                </div>
              </div>

          </div>

          <br/>
          <div class="map-container" ref="mapContainer">
            <div id="map-fornitori"></div>

            <div ref="zoomHint" class="leaflet-ctrl-zoom-hint">
              Premi il tasto "CTRL" e scorri per lo zoom
            </div>

          </div>
          <div id="lista-fornitori">
            <div
                class="fornitore-card" :class="`${f.bgcolor}`"
                v-for="f in filtered_fornitori_aziendali"
                :key="f.id"
            >
              <div class="card-header" :class="`${f.bgcolor}`">
                <h3 class="card-title">{{ f.nome }} {{f.cognome}}</h3>
              </div>

              <div class="card-body">
                <p class="card-desc">{{ f.nome_categ_servizio }}</p>

                <div class="card-row">
                  <span class="label">📍</span>
                  <span class="value">{{ f.indirizzo }} - {{f.cap}}, {{f.comune}}</span>
                </div>

                <div class="card-row">
                  <span class="label">📞</span>
                  <span class="value">{{ f.tel }}</span>
                </div>
                <a :href="`/sellers/vetrina-fornitore/${f.id}`" class="card-link" target="_self">
                  🌐 Scopri i pacchetti
                </a>
              </div>
            </div>
          </div>

        </div>

      </b-card>
    </CustomOverlay>
    <!-- Disclaimer per l'accettazione delle condizioni circa le informazioni -->
    <!-- da dare sui parenti -->
    <DisclaimerCondizioni/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import DisclaimerCondizioni from '@/components/fornitori/DisclaimerCondizioni'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';



export default {
  name: 'HomeFornitori',
  data () {
    return {

      windowWidth: window.innerWidth,

      // Variabili generali
      tagline_elem : [ { text : "Convenzioni special/On Demand", link : 'home-fornitori' } ],
      overlay_show: false,

      // Array delle categorie disponibili
      categorie : null,

      // Array dei fornitori disponibili (e per filtraggio tramite input box)
      fornitori: null,

      //variabili gestione mappa
      map: null,
      allMarkersData: [],   // dati grezzi da API
      markerLayer: null,    // LayerGroup con i marker attivi
      filterText: "",
      filtered_fornitori_aziendali: [],

      isOpen: false,            //apertura menu selezione nome_categ_servizio
      availableCategories: [],  //nome_categ_servizio disponibili
      selectedCategories: [],   //nome_categ_servizio selezionati (per vetrina aziendali)


      //select delle provincie
      selectedProvince: 'no_prov',
      selectedProvinceMarca : 'no_prov',
      selectedProvinceAziendali: 'no_prov',
      optionsProvince: [{value: 'no_prov', text: 'Seleziona Provincia'}],
      optionsProvinceAziendali: [{value: 'no_prov', text: 'Seleziona Provincia'}],
      optionsProvinceMarca: [{value: 'no_prov', text: 'Seleziona Provincia'}],

      // Tre flag, il primo renderizza il menù di tutte le categorie,
      // il secondo renderizza il menù di tutti i fornitori che non sono quelli
      // aziendali, ed il terzo renderizza invece l'elenco dei fornitori
      // aziendali i quali hanno una divisione grafica per comune e quindi un
      // diverso html rispetto agli altri fornitori.
      // Tutti e tre i flag dovrebbero essere attivi solo uno alla volta!
      show_categorie: true,
      show_fornitori: false,
      show_fornitori_map : false,
      show_fornitori_aziendali : false,
      show_fornitori_marche: false,

      // Id della specifica categoria di fornitori da visualizzare
      forn_categ: null,

      // *** FORNITORI AZIENDALI ***
      // Id della categoria dei fornitori aziendali, per loro abbiamo un rendering diverso.
      id_forn_aziendali: 8,
      id_forn_speacial: 11,
      id_forn_marche: 12,

      // Un'array dove in fase di creazione della pagina metto i soli fornitori aziendali
      // per poter fare azioni di filtraggio sulla loro pagina.
      forn_aziendali : [],

      // Select per la pagina dei fornitori aziendali usata per filtrare per categoria di servizio
      forn_azi_select_filter : {
        selected: null,
        options : [ { value: null, text: 'Tutte' } ]
      },

      // Variabile per la ricerca testuale per nome dei fornitori aziendali
      forn_azi_text_search : "",

      modalVisible: false,
      modalTitle: ''
    }
  },
  watch: {
    /**
     * Il Watcher controlla lo stato delle due variabili relative al filtro
     * per categoria di servizo e nome aggiunto nella apgina dei fornitori aziendali.
     * Al variare di una delle due richiama la funzione che effettua il filtraggio
     * dei fornitori e reimposta l'array forn_aziendali inserendovi solo quelli che
     * rispondono a quanto selezionato.
     */
    'forn_azi_select_filter.selected'() {
      this.filtra_fornitori_aziendali();
    },
    forn_azi_text_search ( new_value ) {
      this.filtra_fornitori_aziendali();
    },
    'selectedProvinceAziendali' () {
      this.filtra_fornitori_aziendali();
    },

  },
  updated: function () {
    this.$nextTick(function () {
      if (this.show_fornitori_aziendali && this.map===null) {
        this.initMap()
        this.display_map(8)
        this.updateMarkers()

      }
    })
  },
  mounted() {
    //this.initMap();
  },
  computed : {
    /**
     * Ripartisce le categorie in un'array di array di modo tale da avere
     * categ_by_row elementi in ogni sotto array e cioè categ_by_row elementi
     * per ogni riga.
     */
    parted_category() {
      if (this.windowWidth >= 1200) return generalLib.sub_array_partition(this.categorie, 3)
      else return generalLib.sub_array_partition(this.categorie, 2)
    },
    /**
     * Ripartisce i fornitori in un'array di array di modo tale da avere
     * forn_by_row elementi in ogni sotto array e cioè forn_by_row elementi
     * per ogni riga.
     * Se settata la variabile interna relativa, mostra solo i fornitori
     * di una ben precisa categoria.
     */
    /*
    parted_forn : function () {
      // Filtro i fornitori se settata una ben determinata categoria da mostrare
      // prima di partizionarli.
      if ( this.forn_categ != null && this.fornitori != null ){
        let forn_filtrati = this.fornitori.filter( ( value ) => { return value.id_categoria === this.forn_categ } );
        return generalLib.sub_array_partition( forn_filtrati, this.forn_by_row );
      }
      return generalLib.sub_array_partition( this.fornitori, this.forn_by_row );
    },

     */

    filter_by_provice: function () {
      if ( this.forn_categ != null && this.fornitori != null ){
        let forn_filtrati = this.fornitori.filter( ( value ) => {return ((value.prov_name === this.selectedProvince || this.selectedProvince === 'no_prov') && value.id_categoria === this.id_forn_speacial) } );
        if (this.windowWidth >= 1200) return generalLib.sub_array_partition(forn_filtrati, this.categ_by_row)
        else return generalLib.sub_array_partition(forn_filtrati, 2)
      }
      return generalLib.sub_array_partition( this.fornitori, this.forn_by_row );
    },

    filter_by_provice_by_marca: function () {
      if ( this.forn_categ != null && this.fornitori != null ){
        let forn_filtrati = this.fornitori.filter( ( value ) => {return ((value.prov_name === this.selectedProvinceMarca || this.selectedProvinceMarca === 'no_prov') && value.id_categoria === this.id_forn_marche) } );
        if (this.windowWidth >= 1200) return generalLib.sub_array_partition(forn_filtrati, this.categ_by_row)
        else return generalLib.sub_array_partition(forn_filtrati, 2)
      }
      return generalLib.sub_array_partition( this.fornitori, this.forn_by_row );
    },

    /**
     * I fornitori aziendali devono avere un rendering diverso che li divide per provincie,
     * per questo nel caso in cui venga aperta la loro sezione si richiama questo metodo
     * al posto del metodo "parted_forn" qui sopra. Qui inoltre attingiamo alla loro
     * array specifica forn_aziendali in quanto possiamo fare su di tale array delle
     * azioni di filtro per visualizzarne solo una parte.
     */
    parted_forn_aziendali : function () {

      // Devo dividere i fornitori in primo luogo per provincia, costruisco quindi un
      // oggetto dove la chiave è la provincia ed il valore sono i fornitori che vi
      // appartengono
      let forn_by_prov = {}

      for ( let forn of this.forn_aziendali ) {
        // Se la chiave con il nome della provincia non esiste la creo.
        if ( !( forn.prov_name in forn_by_prov ) ) {
          forn_by_prov[ forn.prov_name ] = [];
        }
        forn_by_prov[ forn.prov_name ].push( forn );

        // Ad ogni aggiornamento riordino il contenuto dell'array relativa
        // alla specifica provincia in ordine alfabetico usando prima la categoria
        // di servizio, e poi il nome del fornitore
        // Per non fare due ordinamenti diversi costruisco un'unica stringa
        // con categoria di servizio, nome e cognome del fornitore.
        forn_by_prov[ forn.prov_name ].sort( (a, b) =>{
          let a_name = a.nome_categ_servizio + ' ' + a.nome + ' ' + a.cognome;
          let b_name = b.nome_categ_servizio + ' ' + b.nome + ' ' + b.cognome;
          if ( a_name > b_name ) return 1;
          if ( a_name < b_name ) return -1;
          return 0;
        });
      }

      // Ora divido i fornitori di ogni provincia con la solita funzione
      // sub_array_partition per avere N elementi per ogni riga in ogni
      // provincia.
      for ( let prov in forn_by_prov ) {
        forn_by_prov[ prov ] = generalLib.sub_array_partition( forn_by_prov[ prov ], this.forn_by_row );
      }

      // Infine prima di tornare ordino anche le pronvincie nell'oggetto in ordine alfabetico:
      // - keys: prende le chiavi dell'oggetto ( le provincie )
      // - sort: ordina le chiavi ( le provincie ) in ordine alfabetico
      // - reduce: cicla l'array delle chiavi ordinate ricreando un nuovo oggetto con le provincie
      //           ordinate.
      return Object.keys( forn_by_prov ).sort().reduce((accumulator, key) => {
                                                          accumulator[key] = forn_by_prov[key];
                                                          return accumulator;
                                                        }, {});

    },
    /**
     * In base allo stato di visualizzazione della pagina ( se visualizziamo le categorie od i fornitori )
     * andiamo amodificare il sottotitolo della card che contiene il tutto.
     */
    home_subtitle : function () {
      if ( this.show_categorie === true && this.show_fornitori == false && this.show_fornitori_aziendali == false ) {
        return 'Scegli tra le categorie a disposizione.'
      }
      if ( this.show_categorie === false && ( this.show_fornitori == true || this.show_fornitori_aziendali == true )) {
        return 'Scegli tra i nostri servizi quelli su misura per te.'
      }
      return '';
    },

    //comanda la lista di categorie (selezionate) da mostrare come chip nel relativo menu di filtro per la mappa
    filteredCategories() {
      return this.availableCategories.filter(c => this.selectedCategories.includes(c.value));
    }


  },
  methods : {

    // Inizializza la mappa
    initMap() {
      this.map = L.map('map-fornitori',{
        scrollWheelZoom: false,
        zoomControl: true
      }).setView([42.5, 12], 6);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);


      const zoomHint = this.$refs.zoomHint;
      const container = this.$refs.mapContainer;
      let hideTimeout = null;

      container.addEventListener("wheel", (e) => {
        const isCtrl = e.ctrlKey;

        if (isCtrl) {
          this.map.scrollWheelZoom.enable();

          zoomHint.classList.remove("show");

          //disabilita lo zoom dopo un momento
          clearTimeout(this.map._ctrlTimeout);
          this.map._ctrlTimeout = setTimeout(() => {
            this.map.scrollWheelZoom.disable();
          }, 200);
          //attivare questo se non si vuole lo scroll della pagina quando si passa sulla mappa e NON si preme CTRL
          e.preventDefault();
        } else {
          //blocca lo zoom
          this.map.scrollWheelZoom.disable();

          //mostra overlay stile Google Maps
          zoomHint.classList.add("show");

          clearTimeout(hideTimeout);
          hideTimeout = setTimeout(() => {
            zoomHint.classList.remove("show");
          }, 1500);


        }
      }, { passive: false });


    this.markerLayer = L.layerGroup().addTo(this.map);
    },

    //crea e configura un marker da visualizzare sulla mappa, con il popup da mostrare quando si effettua il click
    setupMarker: function (fornitore) {
      //creo un marker solo se il relativo fornitore ha delle coordinate
      if (fornitore.latitude!=null && fornitore.longitude!=null) {

        //associo un'icona al marker
        let iconUrl = ''
        //differenzio l'icona mostrata in base alla tipologia del fornitore (campo nome_categ_servizio)
        switch (fornitore.nome_categ_servizio) {
          case 'Benessere': { iconUrl = '/img/icons/Marker_Benessere.svg'; break; }
          case 'Conciliazione Vita-Lavoro': { iconUrl = '/img/icons/Marker_ConciliazioneVitaLavoro.svg'; break; }
          case 'Corsi di Formazione/Sviluppo Personale': { iconUrl = '/img/icons/Marker_CorsiFormazioneSviluppoPersonale.svg'; break; }
          case 'Cultura e Culto': { iconUrl = '/img/icons/Marker_CulturaCulto.svg'; break; }
          case 'Pacchetti Assicurativi': { iconUrl = '/img/icons/Marker_PacchettiAssicurativi.svg'; break; }
          case 'Prestazioni Sanitarie': { iconUrl = '/img/icons/Marker_PrestazioniSanitarie.svg'; break; }
          case 'Sport': { iconUrl = '/img/icons/Marker_Sport.svg'; break; }
          case 'Vetrina Fornitori Aziendali': { iconUrl = '/img/icons/Marker_Vetrina.svg'; break; }
          case 'Viaggi Vacanze ed Eventi': { iconUrl = '/img/icons/Marker_ViaggiVacanzeEventi.svg'; break; }
          case 'Welfare Km 0': { iconUrl = '/img/icons/Marker_WelfareKm0.svg'; break; }
          default: { iconUrl = '/img/icons/Marker_Vetrina.svg'; break; }
        }
        const markerIcon = L.icon({
          iconUrl: iconUrl,
          iconSize: [50, 62],
        });
        //associo un popup al marker
        const popupContent = `
          <div class="category-badge">
            <h3>${fornitore.nome}  ${fornitore.cognome}</h3>
            <p style="font-style:italic">${fornitore.nome_categ_servizio}</p>
            <p> 📍 ${fornitore.indirizzo}, ${fornitore.comune} (${fornitore.provincia})</p>
            <p> 📞 ${fornitore.tel}</p>
            <p><a href="/sellers/vetrina-fornitore/${fornitore.id}" target="_self" class="card-link">🌐 Scopri i pacchetti</a></p>
          </div>`;
        const aMarker =  L.marker({lat: fornitore.latitude, lng: fornitore.longitude},{ icon: markerIcon }
          ).bindPopup(popupContent);

        return aMarker;

      }
    },
    display_map: function ( id_categ ) {

      this.forn_categ = id_categ;
      this.show_categorie = false;
      this.show_fornitori = false;

      if ( this.forn_categ == this.id_forn_aziendali ) {
        this.show_fornitori_aziendali = true;
      } else {
        this.show_fornitori_map = true;
      }
    },

    //aggiorna i marker sulla mappa allo start della pagina e in funzione delle selezioni filtri
    updateMarkers() {
      // pulisce i vecchi marker
      this.markerLayer.clearLayers();
      //filtra i fornitori in base a box di ricerca e categorie servizio selezionate (se non selezionate cerco su tutte)
      //il box di ricerca cerca in nome fornitore, indirizzo e comune
      if (this.filterText.toLowerCase()!=='') {
          this.filtered_fornitori_aziendali = this.forn_aziendali.filter(f =>
              (f.nome.toLowerCase().includes(this.filterText.toLowerCase()) ||
            f.comune.toLowerCase().includes(this.filterText.toLowerCase()) ||
            f.indirizzo.toLowerCase().includes(this.filterText.toLowerCase())) &&
              (this.selectedCategories.includes(f.nome_categ_servizio) || this.selectedCategories.length===0 )
        )
      } else {
        //non ho immesso nulla nel box di ricerca, filtro soltanto in base alle categorie selezionate (se non selezionate, cerco su tutte)
        this.filtered_fornitori_aziendali = this.forn_aziendali.filter(f => this.selectedCategories.includes(f.nome_categ_servizio) || this.selectedCategories.length===0)
      }
      // crea marker per i soli compatibili con i filtri
      this.filtered_fornitori_aziendali.forEach(fornitore => {
        const marker = this.setupMarker(fornitore);
        if (marker)
          this.markerLayer.addLayer(marker);
      });
    },
    //alla modifica del box di ricerca testuale aggiorna i marker sulla mappa
    applyFilter() {
      this.updateMarkers();
    },
    //all'inserimento di una categoria di servizio tra le selezionate aggiorna i marker sulla mappa
    toggleCategory(value) {
      const i = this.selectedCategories.indexOf(value);
      if (i === -1) this.selectedCategories.push(value);
      else this.selectedCategories.splice(i, 1);
      this.updateMarkers()
    },
    //alla rimozione di una categoria di servizio aggiorna i marker sulla mappa
    removeCategory(value) {
      const i = this.selectedCategories.indexOf(value);
      if (i !== -1) this.selectedCategories.splice(i, 1);
      this.updateMarkers()
    },

  /**
     * Wrapper per la funzione di libreria omonima, senza il wrapper non potrei
     * richiamarla direttamente dal template.
     * Data un'array partizionata per visualizzare gli elementi da scegliere
     * ( categorie o fornitori ) calcola la giusta classe boostrap da dare alle
     * colonne per spaziare adeguatamente il contenuto.
     */
    calculate_bootstrap_col_class : function ( parted_array ) {
      return generalLib.calculate_bootstrap_col_class( parted_array );
    },
    /**
     * Visualizza la lista delle categorie nascondendo il resto, resetta categoria
     * settata per i fornitori e l'id del fornitore da mostrare in vetrina.
     */
    display_categorie: function () {
      this.forn_categ = null;
      this.show_fornitori = false;
      this.show_fornitori_aziendali = false;
      this.show_fornitori_map = false;
      this.show_fornitori_marche = false;
      this.show_categorie = true;
    },
    /**
     * Visualizza la lista dei fornitori, il cui id di categoria viene passato alla funzione.
     * Resetta un eventuale id fornitore da visualizzare settato precedentemente.
     * Se abbiamo scelto la vetrina dei fornitori aziendali, che deve avere un rednering a parte,
     * setta in visualizzazione l'apposito flag.
     *
     * - id_categ : id della categoria dei fornitori da visualizzare. Sono visualizati
     *              solo i fornitori appartenenti a tale categoria.
     */
    display_fornitori: function ( id_categ ) {
      this.forn_categ = id_categ;
      this.show_categorie = false;
      this.show_fornitori_map = false;

      if ( this.forn_categ === this.id_forn_aziendali ) {
        this.show_fornitori_aziendali = true;
      }else if(this.forn_categ === this.id_forn_speacial){
        this.show_fornitori = true;
      } else {
        this.show_fornitori_marche = true;
      }

    },

    /**
     * Visualizza la vetrina del fornitore o del consorzio a seconda della tipologia
     * del fornitore passatogli.
     *
     * - obj_fornitore: oggetto con le info del fornitore/consorzio per la quale
     *                  dobbiamo aprire la vetrina.
     */
    apri_vetrina: function ( obj_fornitore ) {
      if ( obj_fornitore.is_consorzio === true ) {
        this.$router.push( { name : 'vetrina-consorzio', params : { id_consorzio : obj_fornitore.id } } );
      } else {
        this.$router.push( { name : 'vetrina-fornitore', params : { id_fornitore : obj_fornitore.id } } );
      }
    },
    /**
     * Usata al created appena dopo aver caricato le categorie, va a popolare
     * l'array specifica per i fornitori aziendali forn_aziendali ( necessaria in quanto
     * su di essa possono essere fatte delle azioni di filtro ) e le opzioni per
     * il filtro di select per categorie.
     */
    inizializza_fornitori_aziendali : function () {
      // Prendo solo i fornitori aziendali per popolare l'array relativa
      this.forn_aziendali = this.fornitori.filter( ( value ) => { return value.id_categoria === this.id_forn_aziendali } );
      this.forn_aziendali = this.forn_aziendali.map(f => {return { "bgcolor": f.nome_categ_servizio.replace(/[^a-zA-Z0-9]/g, '_').toLowerCase()
                                ,...f }})
      if (this.show_forn_aziendali)
        this.updateMarkers()
      // Inserico le categorie di servizio di questi fornitori alle opzioni della select che fa da filtro per
      // tali categorie.
      let serv_categ_added = []; // Un'array di lavoro dove segnare gli id delle categorie che ho già aggiunto
      let options = []
      for ( let forn of this.forn_aziendali ) {
        if ( serv_categ_added.indexOf( forn.id_categ_servizio ) == -1 ){
          serv_categ_added.push(forn.id_categ_servizio);
          options.push( { value: forn.id_categ_servizio, text: forn.nome_categ_servizio } )
        }
      }

      // Ora ordino alfabeticamente gli elemnti e poi li concateno all'array della select, facciamo così
      // di modo tale che l'opzione di default "Tutte" sia sempre la prima della lista ed a seguire ci
      // siano le altre ordinate sempre alfabeticamente.
      options.sort( (a ,b) => {
        if( a.text > b.text ) return 1;
        if( a.text < b.text ) return -1;
        return 0;
      });

      this.forn_azi_select_filter.options = this.forn_azi_select_filter.options.concat( options );
      //categorie di fornitori per la mappa (solo aziendali)
      this.availableCategories = [
        ...new Set(this.forn_aziendali.map(f => f.nome_categ_servizio))
      ].map(cat_servizio => ({
        value: cat_servizio,
        label: cat_servizio
      }));
    },

    /**
     * Viene invocata nei due watcher che verificano rispettivamente lo stato della select che filtra per categorie
     * e quella che invece fa inserire il nome azienda da ricercare.
     * Ricostruisce quindi l'array forn_aziendali in base a come i filtri sono stati impostati.
     */
    filtra_fornitori_aziendali : function () {

        // Filtro per categoria di servizio e nome azienda
        this.forn_aziendali = this.fornitori.filter((value) => {
          let nome_azienda = value.nome + " " + value.cognome;
          nome_azienda = nome_azienda.toLowerCase();

          return (value.id_categoria === this.id_forn_aziendali) &&
              (nome_azienda.search(this.forn_azi_text_search.toLowerCase()) !== -1 || this.forn_azi_text_search.trim().length === 0 ) &&
              (value.id_categ_servizio === this.forn_azi_select_filter.selected || this.forn_azi_select_filter.selected === null) &&
              (value.prov_name === this.selectedProvinceAziendali || this.selectedProvinceAziendali ==='no_prov')
        });
    },onResize: function () {
      this.windowWidth = window.innerWidth
    }
  },
  /**
   * Carichiamo i fornitori e relative categorie disponibili per l'utente
   */
  created : function () {

    this.overlay_show = true;

    // Carichiamo prima i fornitori disponibili e poi in cascata le categorie,
    // per la quale filtriamo le sole relative ai fornitori.
    axios.get( apiUrl.fornitoriapi.get_fornitori_disponibili )
    .then( ( response ) => {

      this.fornitori = response.data;

      //tiene traccia delle provincie in modo da non inserire i duplicati
      const no_repeat_prov = []
      const no_repeat_provAziendali = [];
      const no_repeat_prov_marche = []

      this.fornitori.forEach((fornitori) => {
        if (fornitori.id_categoria === this.id_forn_aziendali) {

          if (!no_repeat_provAziendali.includes(fornitori.prov_name)) {
            this.optionsProvinceAziendali.push({value: fornitori.prov_name, text: fornitori.prov_name});
            no_repeat_provAziendali.push(fornitori.prov_name);
          }

        } else if(fornitori.id_categoria === this.id_forn_speacial) {

          if (!no_repeat_prov.includes(fornitori.prov_name)) {
            this.optionsProvince.push({value: fornitori.prov_name, text: fornitori.prov_name});
            no_repeat_prov.push(fornitori.prov_name);
          }

        }else if(fornitori.id_categoria === this.id_forn_marche){
          if (!no_repeat_prov_marche.includes(fornitori.prov_name)) {
            this.optionsProvinceMarca.push({value: fornitori.prov_name, text: fornitori.prov_name});
            no_repeat_prov_marche.push(fornitori.prov_name);
          }
        }
      })
      // Ora carichiamo le categorie ed inizializziamo i fornitori aziendali che
      // hanno una gestione separata.
      axios.get( apiUrl.fornitoriapi.get_categorie )
      .then( ( response ) => {
        // Segnamoci gli id delle categorie dei fornitori
        let id_categ_forn = this.fornitori.map( ( val ) => { return val.id_categoria } );
        // Poniamo nelle categorie solo quelle relative ai fornitori abilitati
        this.categorie = response.data.filter( ( elem ) => { return id_categ_forn.includes( elem.id ) } );
        // Popoliamo l'array dei fornitori aziendali ed il filtro per categorie
        this.inizializza_fornitori_aziendali()

        this.overlay_show = false;
      })
      .catch( ( error ) => {
        this.overlay_show = false;
        let message = "Si è verificato un errore nel caricamento delle informazioni sulle categorie, " +
                      "si prega di riprovare, se il problema persiste contattare l'assistenza";
        generalLib.backend_error_message_box( this, message );
        console.error( error.response.data );
      });

    })
    .catch( ( error ) => {
      this.overlay_show = false;
      let message = "Si è verificato un errore nel caricamento delle informazioni sui fornitori, " +
                    "si prega di riprovare, se il problema persiste contattare l'assistenza";
      generalLib.backend_error_message_box( this, message );
      console.error( error.response.data );
    })

    window.addEventListener('resize', this.onResize);

  },
  beforeDestroy() {
      if (this.map) {
          this.map.remove();
      }
    window.removeEventListener('resize', this.onResize)

  },

  props : {
    /**
     * Numero massimo di categorie da visualizzare per ogni riga
     */
    categ_by_row: {
      type: Number,
      default: 4,
      validator: function (value) {
        // Non possiamo ospitare più di 12 elementi per riga.
        // Cioè le 12 colonne consentite da bootstrap.
        return value <= 12;
      }
    },
    /**
     * Numero massimo di fornitori da visualizzare per ogni riga
     */
    forn_by_row: {
      type: Number,
      default: 4,
      validator: function (value) {
        // Non possiamo ospitare più di 12 elementi per riga.
        // Cioè le 12 colonne consentite da bootstrap.
        return value <= 12;
      }
    }
  },
  components: {
    PageTagline,
    CustomOverlay,
    DisclaimerCondizioni
  }
}
</script>


<style scoped>
/* stile dei badge per le categorie */
.category-badge {
  display: inline-block;
  border : 1px solid rgba(0,0,0,.125);
  border-radius: 10px;
  padding: 10px 10px 20px 10px;
  text-decoration: none;
  color: #000000;
}
.category-badge:hover img{
  filter: blur(1px);
}
.category-badge:hover {
  background: #ebebeb;
  color: #636363;
}

/* Css dei badge per mostrare i fonitori */
.forn-badge {
  display: inline-block;
  border : 1px solid rgba(0,0,0,.125);
  border-radius: 10px;
  padding: 10px 10px 20px 10px;
  text-decoration: none;
  color: #000000;
  width: 400px;
}

.forn-badge:hover img{
  filter: blur(1px);
}

.forn-badge:hover {
  background: #ebebeb;
  color: #636363;
}

/* Sistemiamo la larghezza dei badge a seconda della grandezza del viewport,
   dalla risoluione più piccola a quella più grande */
@media (max-width: 576px) {
  .forn-badge {
    width: 100%;
  }
}

@media (min-width: 577px) and (max-width: 991px) {
  .forn-badge {
    width: 80%;
  }
}

@media (min-width: 992px) and (max-width: 1500px) {
  .forn-badge {
    width: 65%;
  }
}

@media (min-width: 1501px) and (max-width: 1705px) {
  .forn-badge {
    width: 50%;
  }
}

@media (min-width: 1706px) {
  .forn-badge {
    width: 400px;
  }
}


/* Classe container specifica per i fornitori NON AZIENDALI che hanno
   solo il nome e non il logo, riproduce un quadrato di 200x240px
   in modo da simulare la grandezza dei loghi.
   Prima la grandezza era di 200x200 ma ora con l'aggiunta della
   categoria di servizio l'altezza è aumentata di 40 px. */
.forn-name-container {
  width: 200px;
  height: 200px;
  margin: auto;
  padding-top: 40px;
}


/* Classi Container per il forn-badge ridefinite per i fornitori aziendali
   in questo caso abbiamo sia la parte sopra del logo o nome
   che quella sotto con la categoria di servizio.
   Creiamo un container un pò più alto in questo caso ( 50px in più )
   di modo tale che possiamo ospitarvi la classe di servizio*/
.forn-info-container {
  height: 250px;
  margin: auto;
}

/* Il div che ospita il nome od il logo lo facciamo alto
   200px di modo tale che possa entravi bene il logo del
   fornitore che è di 200x200 */
.forn-badge-name-logo {
  height: 200px;
}

/* Il resto dello spazio sarà per il nome della categoria di servizio */
.forn-badge-servcateg {
  font-style: italic;
  color: #767676;
}

.selectedCard{
  cursor: pointer;
}

.selectedCard:hover {
  background-color: whitesmoke;
  border-radius: 20px;
}

#map-fornitori {
  height: 800px;
  width: 100%;
  border-radius: 12px;
  border: 2px solid transparent;
  margin-bottom:26px;
  background: linear-gradient(#fff, #fff) padding-box,
  linear-gradient(45deg, #575f86, #777fA6 ) border-box;

}


.map-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.leaflet-ctrl-zoom-hint {
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(40, 40, 40, 0.9);
  color: white;
  padding: 8px 14px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.leaflet-ctrl-zoom-hint.show {
  opacity: 1;
}


.filters-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start; /* allineati a sinistra */
  width: 100%;
  gap: 10px; /* piccolo spazio tra gli input */
  align-items: stretch;  /* fa sì che entrambi i contenitori abbiano stessa altezza */
}


/*style per box di ricerca*/
.search-box {
  display: flex;
  flex: 1;
  min-width: 50%;
}
.search-input {
  width: 100%;
  padding: 12px 10px 14px 12px;
  border-radius: 12px;
  border: 2px solid transparent;
  background: linear-gradient(#fff, #fff) padding-box,
  linear-gradient(45deg, #575f86, #777fA6 ) border-box;
  font-size: 16px;
  transition: 0.3s;
}

.search-input:focus {
  border-color: transparent;
  box-shadow: 0 0 8px rgba(74, 144, 226, 0.4);
}

/*style per card*/
#lista-fornitori {
  display: grid;
  gap: 40px;
  margin: 0 auto;
}

/* Mobile: 1 card per riga */
#lista-fornitori {
  grid-template-columns: 1fr;
  justify-items: center;
}

/* Da 768px in su: 2 card per riga */
@media (min-width: 768px) {
  #lista-fornitori {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1280px) {
  #lista-fornitori {
    grid-template-columns: repeat(3, 1fr);
  }
}


.fornitore-card {
  background: #fff !important;
  border-radius: 14px;
  overflow: hidden;
  width: 100%;
  cursor: pointer; /* opzionale, dà l’idea di interattivo */
}

.fornitore-card:hover {
  transform: translateY(-6px) scale(1.02);   /* sollevamento + leggero zoom */
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.28); /* ombra più forte */
}


.card-header {
  padding: 14px 20px;
  color: #fff;
}
.non_definito {
  color:#000;
  background: linear-gradient(135deg, #575f86, #676fA6);
  border: 1px solid #575f86;
}
.benessere {
  color:#000;
  background: linear-gradient(135deg, #10B981, #40E9B1);
  border: 1px solid #10B981;
}
.conciliazione_vita_lavoro {
  color:#000;
  background: linear-gradient(135deg, #8B5CF6, #BB8CF6);
  border: 1px solid #8B5CF6;
}
.corsi_di_formazione_sviluppo_personale {
  color:#000;
  background: linear-gradient(135deg, #EF4444, #FF7474);
  border: 1px solid #EF4444;
}
.cultura_e_culto {
  color:#000;
  background: linear-gradient(135deg, #F59E0B, #FFCE3B);
  border: 1px solid #F59E0B;
}
.pacchetti_assicurativi {
  color:#000;
  background: linear-gradient(135deg, #EC4899, #FF78B9);
  border: 1px solid #EC4899;
}
.prestazioni_sanitarie {
  color:#000;
  background: linear-gradient(135deg, #3B82F6, #6BB2F6);
  border: 1px solid #3B82F6;
}
.sport {
  color:#000;
  background: linear-gradient(135deg, #06B6D4, #36E6F4);
  border: 1px solid #06B6D4;
}
.vetrina_fornitori_aziendali {
  color:#000;
  background: linear-gradient(135deg, #84CC16, #B4FC46);
  border: 1px solid #84CC16;
}
.viaggi_vacanze_ed_eventi {
  color:#000;
  background: linear-gradient(135deg, #F97316, #FFA346);
  border: 1px solid #F97316;
}
.welfare_km_0 {
  color:#000;
  background: linear-gradient(135deg, #14B8A6, #34E8D6);
  border: 1px solid #14B8A6;
}

.card-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.card-body {
  padding: 18px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 150px;
}

.card-desc {
  margin: 0;
  color: #555;
  font-size: 14px;
  line-height: 1.4;
  font-style: italic;
}

.card-row {
  display: flex;
  gap: 6px;
  font-size: 14px;
}

.label {
  font-weight: 600;
  color: #444;
}

.value {
  color: #555;
}

.card-link {
  margin-top: 10px;
  display: inline-block;
  font-weight: 600;
  text-decoration: none;
  font-size: 14px;
}

.card-link:hover {
  text-decoration: underline;
}



/* style per selezione categorie */
.multi-select {
  position: relative; /*permette l'allineamento in larghezza tra pannello con voci di menu e menu (chiuso) */
  display: flex;
  flex: 1;
  min-width: 50%;

}

.multi-select-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding: 12px 10px 14px 12px;
  background: #fff;
  background: linear-gradient(#fff, #fff) padding-box,
  linear-gradient(45deg, #575f86, #777fA6 ) border-box;
  border: 2px solid transparent;
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  width:98.75%;
  }

.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  display: flex;
  align-items: center;
  border-radius: 12px;
  padding: 3px 8px;
  background: linear-gradient(135deg, #474f76, #676f96);
  color:#fff;
  font-size: 16px;
}

.chip-remove {
  margin-left: 6px;
  cursor: pointer;
  font-weight: bold;

}

.arrow {
  transition: transform .2s;
  padding-right:6px;
}

.arrow.open {
  transform: rotate(180deg);
}

.multi-select-menu {
  position: absolute;   /*permette al menu di aprirsi sopra alla mappa, per il solo tempo per cui è aperto*/
  margin-top: 5px;
  top:100%;
  width:100%;
  left:0;
  background: linear-gradient(#fff, #fff) padding-box,
  linear-gradient(45deg, #575f86, #777fA6 ) border-box;
  border-radius: 12px;
  padding: 10px 10px 10px 12px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  z-index: 1000;
}

.multi-select-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  cursor: pointer;
}

.multi-select-item input[type="checkbox"] {
  transform: scale(1.4);   /* aumenta la dimensione della checkbox */
  margin-right: 8px;        /* separazione dal testo */
  cursor: pointer;
}

.multi-select-item:hover {
  background: #f2f2f2;
}

</style>